var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterWatermark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 408,
    viewBox: "0 0 408 408",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05,
    clipPath: "url(#clip0_13503_5739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.353 382.515C120.532 386.082 127.697 408 203.85 408H204.152C280.304 408 287.499 386.082 288.648 382.515C289.827 378.948 292.155 368.065 288.467 352.435C269.754 276.978 217.333 243.149 204.122 243.149H203.819C190.608 243.149 138.187 276.978 119.474 352.435C115.786 368.065 118.144 378.948 119.293 382.515H119.353Z",
    fill: "#E18A81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.648 25.4849C287.499 21.9176 280.304 0 204.152 0H203.85C127.697 0 120.502 21.9176 119.354 25.4849C118.175 29.0522 115.847 39.9354 119.535 55.5649C138.248 131.022 190.669 164.851 203.88 164.851H204.182C217.393 164.851 269.814 131.022 288.527 55.5649C292.215 39.9354 289.857 29.0522 288.709 25.4849H288.648Z",
    fill: "#E18A81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4849 119.352C21.9176 120.531 0 127.696 0 203.849V204.151C0 280.303 21.9176 287.498 25.4849 288.647C29.0522 289.826 39.9354 292.154 55.5649 288.466C131.022 269.753 164.851 217.332 164.851 204.121V203.818C164.851 190.607 131.022 138.186 55.5649 119.473C39.9354 115.785 29.0522 118.143 25.4849 119.292V119.352Z",
    fill: "#E18A81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.515 288.647C386.082 287.468 408 280.303 408 204.151V203.849C408 127.696 386.082 120.501 382.515 119.353C378.948 118.204 368.065 115.846 352.435 119.534C276.978 138.247 243.149 190.668 243.149 203.879V204.181C243.149 217.392 276.978 269.813 352.435 288.526C368.065 292.214 378.948 289.856 382.515 288.708V288.647Z",
    fill: "#E18A81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13503_5739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 408,
    height: 408,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterWatermark);
export default __webpack_public_path__ + "static/media/footer-watermark.66d4ba80588c32889887c48a26226d32.svg";
export { ForwardRef as ReactComponent };